import { DateFormat, DateVal, getNiceDate, getUserTimezone } from '@/lib/helpers';
import { FC, ReactNode, useMemo } from 'react';
import Text from '../text';

interface Props {
  val: DateVal;
  size?: 'x-large' | 'large' | 'medium' | 'small' | 'x-small';
  withTime?: boolean;
  withOffset?: boolean;
  format?: DateFormat;
}

const NiceDate: FC<Props> = ({
  val,
  size = 'medium',
  withTime = false,
  withOffset = false,
  format = DateFormat.MEDIUM,
}) => {
  const niceDate = useMemo(() => {
    const { timezone } = getUserTimezone();
    return getNiceDate(val, format, timezone);
  }, [val, format]);

  const { formatted, date, timeFull, offset } = niceDate;

  let DateEl: ReactNode[] = [
    <Text size={size} key="formatted">
      {formatted}
    </Text>,
  ];

  if (withTime) {
    DateEl = [
      <Text key="date" size={size}>
        {date}
      </Text>,
      <Text key="time-full" size={size}>
        {timeFull}
      </Text>,
    ];
  }

  if (withOffset) {
    DateEl.push(
      <Text key="offset" size={size}>
        UTC {offset}
      </Text>
    );
  }

  return DateEl;
};

export default NiceDate;
